import React, { useState, SyntheticEvent } from 'react';
import styles from './scaledImage.module.scss';
import defaultLogo from '../../resources/img/bank-logo-placeholder.svg';

interface Props {
    url?: string;
    alt: string;
    scaleWidth: number;
    scaleHeight: number;
}

const ScaledImage: React.FC<Props> = ({ url, alt, scaleWidth, scaleHeight }) => {
    const [toScale, setToScale] = useState(false);
    const [fallback, setFallback] = useState(false);

    const resize = (event: SyntheticEvent<HTMLImageElement, Event>) => {
        const target = event.currentTarget;

        if (target == null) {
            return;
        }

        const imgWidth = target.naturalWidth;
        const imgHeight = target.naturalHeight;
        
        if (imgWidth <= scaleWidth / 2 && imgHeight <= scaleHeight / 2) {
            setFallback(true);
        } else if (imgWidth > scaleWidth || imgHeight > scaleHeight) {
            setToScale(true);
        }
    };

    const handleError = () => {
        setFallback(true);
    };

    const logoUrl = (!url || fallback) ? defaultLogo : url;

    return (
        <img
            className={toScale ? styles.contain : styles.cover}
            src={logoUrl}
            alt={alt}
            onLoad={resize}
            onError={handleError}
        />
    );
};

export default ScaledImage;